/* Create list of actions that can be applied to a shift */
/*
 * List of actions based on status
 * Open:
 *   - Assign
 *   - Cancel
 *   - Edit
 * Pending:
 *   - Approve
 *   - Deny and Open
 *   - Deny and Cancel
 *   - Reassign - notify other nurse they didn't get the shift
 *   - Edit
 * Canceled:
 *   - Reopen - prompt to edit first
 *   - Assign
 *   - Edit
 * Confirmed:
 *   - Reassign
 *   - Cancel
 *   - Edit - Prompt to message nurse
 * Completed:
 *   - Reassign - If another nurse ended up doing the shift
 *   - Cancel - If nurse didn't do the shift
 *   - Edit
 */
import Button from "react-bootstrap/Button";
import {Col, Container, Row} from "react-bootstrap";
import {
  BsArrowCounterclockwise,
  BsBookmarkFill,
  BsCheckCircle,
  BsHandThumbsDownFill,
  BsMailbox,
  BsPencilSquare,
  BsPlusLg,
  BsTrash,
  BsCheckLg,
  BsXCircle,
} from "react-icons/bs";
import {BiSolidPencil, BiXCircle} from "react-icons/bi";
import React from "react";

const isMobile = window.screen.width < 600;

export const ButtonApproveShift = ({ shift, action }) => {
  if (shift?.status === "PENDING" || shift?.status === "PENDING_APPROVAL") {
    return (
      <Col className={"g-3"}>
        <Button
          className={"shift-button-approve icon-text-wrapper"}
          onClick={action}
        >
          <BsCheckCircle
            size={19}
            className={isMobile ? "" : "icon-right-spacing"}
          />
          {isMobile ? "" : "Approve"}
        </Button>
      </Col>
    );
  }
};

export const ButtonAssignShift = ({ shift, action }) => {
  if (
    shift?.status === "OPEN" ||
    shift?.status === "CANCELLED" ||
    shift?.status === "EXPIRED"
  ) {
    return (
      <Col className={"g-3"}>
        <Button
          className={"shift-button-assign icon-text-wrapper"}
          onClick={action}
        >
          <BiSolidPencil
            size={19}
            className={isMobile ? "" : "icon-right-spacing"}
          />
          {isMobile ? "" : "Assign"}
        </Button>
      </Col>
    );
  }
};

export const ButtonCancelShift = ({ shift, action }) => {
  if (
    shift?.status === "OPEN" ||
    shift?.status === "CONFIRMED" ||
    (shift?.status === "COMPLETED" && shift?.timesheet?.status !== "APPROVED")
  ) {
    return (
      <Col className={"g-3"}>
        <Button
          className={"shift-button-cancel icon-text-wrapper"}
          onClick={action}
        >
          <BsXCircle
            size={19}
            className={isMobile ? "" : "icon-right-spacing"}
          />
          {isMobile ? "" : "Cancel"}
        </Button>
      </Col>
    );
  }
};

export const ButtonEditShift = ({ shift, action }) => {
  return (
    <Col className={"g-3"}>
      <Button
        className={"shift-button-edit icon-text-wrapper"}
        onClick={action}
      >
        <BsPencilSquare size={19} />
      </Button>
    </Col>
  );
};

export const ButtonDenyReopenShift = ({ shift, action }) => {
  if (shift?.status === "PENDING" || shift?.status === "PENDING_APPROVAL" || shift?.status === "CONFIRMED") {
    return (
      <Col className={"g-3"}>
        <Button
          className={"shift-button-deny-reopen icon-text-wrapper"}
          onClick={action}
        >
          <BsHandThumbsDownFill
            size={19}
            className={isMobile ? "" : "icon-right-spacing"}
          />
          {isMobile ? "" : "Deny & Reopen"}
        </Button>
      </Col>
    );
  }
};

export const ButtonDenyCancelShift = ({ shift, action }) => {
  if (shift?.status === "PENDING" || shift?.status === "PENDING_APPROVAL") {
    return (
      <Col className={"g-3"}>
        <Button
          className={"shift-button-deny-cancel icon-text-wrapper"}
          onClick={action}
        >
          <BiXCircle
            size={19}
            className={isMobile ? "" : "icon-right-spacing"}
          />
          {isMobile ? "" : "Deny & Cancel"}
        </Button>
      </Col>
    );
  }
};

export const ButtonReassignShift = ({ shift, action }) => {
  if (
    shift?.status === "PENDING" ||
    shift?.status === "PENDING_APPROVAL" ||
    shift?.status === "CONFIRMED" ||
    shift?.status === "COMPLETED" ||
    shift?.status === "EXPIRED"
  ) {
    return (
      <Col className={"g-3"}>
        <Button
          className={"shift-button-reassign icon-text-wrapper"}
          onClick={action}
        >
          <BiSolidPencil
            size={19}
            className={isMobile ? "" : "icon-right-spacing"}
          />
          {isMobile ? "" : "Reassign"}
        </Button>
      </Col>
    );
  }
};

export const ButtonReopenShift = ({ shift, action }) => {
  if (shift?.status === "CANCELLED") {
    return (
      <Col className={"g-3"}>
        <Button
          className={"shift-button-reopen icon-text-wrapper"}
          onClick={() => action()}
        >
          <BsArrowCounterclockwise
            size={19}
            className={isMobile ? "" : "icon-right-spacing"}
          />
          {isMobile ? "" : "Reopen"}
        </Button>
      </Col>
    );
  }
};

export const ButtonNewShift = ({ action }) => {
  return (
    <Col className={"g-3"}>
      <Button
        onClick={() => {
          action();
        }}
        className={"shift-button-new-shift icon-text-wrapper"}
      >
        <BsPlusLg size={19} className={isMobile ? "" : "icon-right-spacing"} />
        {isMobile ? "" : "New Shift"}
      </Button>
    </Col>
  );
};

export const ButtonPendingShift = ({ shift, action }) => {
  if (shift?.status === "OPEN") {
    return (
      <Col className={"g-3"}>
        <Button
          className={"shift-button-pending icon-text-wrapper"}
          onClick={() => action()}
        >
          <BsBookmarkFill
            size={19}
            className={isMobile ? "" : "icon-right-spacing"}
          />
          {isMobile ? "" : "Save as Pending"}
        </Button>
      </Col>
    );
  }
};

export const ButtonSendShiftReminder = ({ shift, action }) => {
  if (shift?.status === "CONFIRMED") {
    return (
      <Col className={"g-3"}>
        <Button
          className={"shift-button-pending icon-text-wrapper"}
          onClick={() => action()}
        >
          <BsMailbox
            size={19}
            className={isMobile ? "" : "icon-right-spacing"}
          />
          {isMobile ? "" : "Send Reminder"}
        </Button>
      </Col>
    );
  }
};

export const ButtonSendTimesheetReminder = ({ shift, action }) => {
  if (
    shift?.status === "COMPLETED" &&
    shift?.timesheet?.status !== "APPROVED" &&
    shift?.digitalTimesheet === true
  ) {
    return (
      <Col className={"g-3"}>
        <Button
          className={"shift-button-pending icon-text-wrapper"}
          onClick={() => action()}
        >
          <BsMailbox
            size={19}
            className={isMobile ? "" : "icon-right-spacing"}
          />
          {isMobile ? "" : "Send Timesheet Reminder"}
        </Button>
      </Col>
    );
  }
};

export const ButtonApproveTimesheet = ({ shift, action }) => {
  if (
    shift?.status === "COMPLETED" &&
    shift?.timesheet?.id !== null &&
    shift?.timesheet?.id !== undefined &&
    shift?.timesheet?.status !== "APPROVED"
  ) {
    return (
      <Col className={"g-3"}>
        <Button
          className={"shift-button-approve icon-text-wrapper"}
          onClick={() => action()}
        >
          <BsCheckCircle
            size={19}
            className={isMobile ? "" : "icon-right-spacing"}
          />
          {isMobile ? "" : "Approve Timesheet"}
        </Button>
      </Col>
    );
  }
};

export const ButtonRejectTimesheet = ({ shift, action }) => {
  if (
    shift?.status === "COMPLETED" &&
    shift?.timesheet?.id !== null &&
    shift?.timesheet?.id !== undefined &&
    shift?.timesheet?.status !== "APPROVED" &&
    shift?.timesheet?.status !== "REJECTED"
  ) {
    return (
      <Col className={"g-3"}>
        <Button
          className={"shift-button-deny-reopen icon-text-wrapper"}
          onClick={() => action()}
        >
          <BsHandThumbsDownFill
            size={19}
            className={isMobile ? "" : "icon-right-spacing"}
          />
          {isMobile ? "" : "Reject Timesheet"}
        </Button>
      </Col>
    );
  }
};

export const ButtonBulkDelete = ({ action }) => {
  return (
    <Col className={"g-3"}>
      <Button
        onClick={() => {
          action();
        }}
        className={"shift-button-deny-reopen icon-text-wrapper"}
      >
        <BsXCircle size={19} className={isMobile ? "" : "icon-right-spacing"} />
        {isMobile ? "" : "Bulk Delete"}
      </Button>
    </Col>
  );
};

export const ButtonNewUser = ({ action }) => {
  return (
    <Col className={"g-3"}>
      <Button
        onClick={() => {
          action();
        }}
        className={"shift-button-new-shift icon-text-wrapper"}
      >
        <BsPlusLg size={19} className={isMobile ? "" : "icon-right-spacing"} />
        {isMobile ? "" : "New User"}
      </Button>
    </Col>
  );
};

export const ButtonEditUser = ({ action }) => {
  return (
    <Col className={"g-3"}>
      <Button
        className={"shift-button-edit icon-text-wrapper"}
        onClick={action}
      >
        <BsPencilSquare size={19} />
      </Button>
    </Col>
  );
};

export const ButtonBlockUser = ({ user, action }) => {
  if (user?.status === "ACTIVE" || user?.status === "HOLD") {
    return (
      <Col className={"g-3"}>
        <Button
          className={"shift-button-cancel icon-text-wrapper"}
          onClick={action}
        >
          <BsXCircle
            size={19}
            className={isMobile ? "" : "icon-right-spacing"}
          />
          {isMobile ? "" : "Block User"}
        </Button>
      </Col>
    );
  }
};

export const ButtonUnBlockUser = ({ user, action }) => {
  if (user?.status === "BLOCKED" || user?.status === "HOLD") {
    return (
      <Col className={"g-3"}>
        <Button
          className={"shift-button-cancel icon-text-wrapper"}
          onClick={action}
        >
          <BsArrowCounterclockwise
            size={19}
            className={isMobile ? "" : "icon-right-spacing"}
          />{" "}
          {isMobile ? "" : "Unblock User"}
        </Button>
      </Col>
    );
  }
};

export const ButtonOnHoldUser = ({ user, action }) => {
  if (user?.status === "ACTIVE") {
    return (
      <Col className={"g-3"}>
        <Button
          className={"shift-button-pending icon-text-wrapper"}
          onClick={action}
        >
          <BsHandThumbsDownFill
            size={19}
            className={isMobile ? "" : "icon-right-spacing"}
          />
          {isMobile ? "" : "Mark User on Hold"}
        </Button>
      </Col>
    );
  }
};

export const ButtonUpdatePassword = ({ action }) => {
  return (
    <Col className={"g-3"}>
      <Button
        className={"shift-button-reassign icon-text-wrapper"}
        onClick={action}
      >
        <BiSolidPencil
          size={19}
          className={isMobile ? "" : "icon-right-spacing"}
        />
        Update Password
      </Button>
    </Col>
  );
};

export const ButtonSubmitTimesheet = ({ shift, action }) => {
  if (
    shift?.status === "COMPLETED" &&
    (shift?.timesheet?.id === null || shift?.timesheet?.id === undefined)
  ) {
    return (
      <Col className={"g-3"}>
        <Button
          onClick={() => {
            action();
          }}
          className={"shift-button-new-shift icon-text-wrapper"}
        >
          <BsPlusLg
            size={19}
            className={isMobile ? "" : "icon-right-spacing"}
          />{" "}
          {isMobile ? "" : "Submit Timesheet"}
        </Button>
      </Col>
    );
  }
};

export const ButtonEditTimesheet = ({ shift, action }) => {
  if (
    shift?.status === "COMPLETED" &&
    shift?.timesheet?.id !== null &&
    shift?.timesheet?.id !== undefined
  ) {
    return (
      <Col className={"g-3"}>
        <Button
          onClick={() => {
            action();
          }}
          className={"shift-button-new-shift icon-text-wrapper"}
        >
          <BsPencilSquare
            size={19}
            className={isMobile ? "" : "icon-right-spacing"}
          />{" "}
          {isMobile ? "" : "Edit Timesheet"}
        </Button>
      </Col>
    );
  }
};

export const ButtonNewCert = ({ action }) => {
  return (
    <Col className={"g-3"}>
      <Button
        onClick={() => {
          action();
        }}
        className={"shift-button-new-shift icon-text-wrapper"}
      >
        <BsPlusLg size={19} className={isMobile ? "" : "icon-right-spacing"} />{" "}
        {isMobile ? "" : "New Certification"}
      </Button>
    </Col>
  );
};

export const ButtonActivateUser = ({ user, action }) => {
  if (user?.status === "PENDING") {
    return (
      <Col className={"g-3"}>
        <Button
          className={"shift-button-approve icon-text-wrapper"}
          onClick={action}
        >
          <BsCheckLg
            size={19}
            className={isMobile ? "" : "icon-right-spacing"}
          />
          {isMobile ? "" : "Activate User"}
        </Button>
      </Col>
    );
  }
};

export const ButtonDeleteUser = ({ user, action }) => {
  if (user?.status === "PENDING") {
    return (
      <Col className={"g-3"}>
        <Button
          className={"shift-button-cancel icon-text-wrapper"}
          onClick={action}
        >
          <BsTrash
            size={19}
            className={isMobile ? "" : "icon-right-spacing"}
          />
          {isMobile ? "" : "Delete User"}
        </Button>
      </Col>
    );
  }
};

export const ShiftShiftButtonActionsElements = ({ shift }) => {
  if (shift === null || shift === undefined) return;

  return (
    <div className={"shift-button-container"}>
      <Container>
        <Row xs={"auto"} className={"justify-content-lg-end shift-button"}>
          <ButtonApproveShift shift={shift} />
          <ButtonDenyReopenShift shift={shift} />
          <ButtonDenyCancelShift shift={shift} />
          <ButtonReopenShift shift={shift} />
          <ButtonAssignShift shift={shift} />
          <ButtonReassignShift shift={shift} />
          <ButtonCancelShift shift={shift} />
          <ButtonEditShift shift={shift} />
        </Row>
      </Container>
    </div>
  );
};
